// extracted by mini-css-extract-plugin
export default {"domainDisplayLayout":"DomainDisplay_domainDisplayLayout__lO2jN","intlMessage":"DomainDisplay_intlMessage__tLwJ3","internationalizedLink":"DomainDisplay_internationalizedLink__GUW6s"};